import React from "react";
import Topbar from "../../components/Topbar";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import Header from "../../components/Header";
import Banner from "../../components/Banner";
import { Link } from "react-router-dom";
import AccountSettings from "../../components/AccountSettings/index";
import Bottombar from "../../components/Bottombar";
import { PAYMENTS } from "../../constants/settingsStrings.js";

function SubcriptionAndPaymentScreen() {
  const text = "";
  return (
    <div className="dark:bg-black bg-white  h-screen overflow-hidden  dark:text-black dark:h-screen">
      <div className="sm:hidden ">
     
        <Topbar />
      </div>
      <div className="hidden md:block">
        <Header />
      </div>
      <div className="sm:hidden    mt-7  ">
        <Link to="/settings/paymentmethod">
          <ArrowLeftIcon color="#545454" className="ml-6 w-[30px] h-[30px]" />
        </Link>

        
      </div>

     
      <div className="">
      <div className="border-2 w-[346px] h-[115px]  rounded-[25px] mt-3 bg-banner2 m-5 relative sm:hidden">
        <div className=" absolute flex  space-x-10">
          <h3 className="text-white font-extrabold  text-[20px] font-sans ml-5 mt-5">
            GO{" "}
            <span className="border bg-[#0049F5]  w-[63px] h-[18px] px-2 text-[14px]   text-white rounded-[16px]">
              PRO
            </span>{" "}
            <br />
            PREMIUM!
          </h3>
        </div>
        <div className="ml-[280px] mt-3">
          <img
            src="https://uibfs.s3.eu-north-1.amazonaws.com/Saly-41.png"
            className="w-[87px] h-[98px]"
            alt=""
          />
        </div>
      </div>
      <div className="sm:flex  sm:justify-center sm:items-center ">
        <div className="hidden md:block">
          <AccountSettings active={PAYMENTS} />
        </div>

        <div className="w-[925px]   sm:w-[64vw] mt-2 h-[500px] rounded-[25px] sm:shadow-xl  sm:mx-10  ">
          <div className=" hidden md:block ">
           
            <Banner />
          </div>
    

      
  <div className="sm:flex sm:flex-col justify-center items-center mt-14 sm:mt-6   space-y-10 sm:space-y-4    ml-10   sm:ml-10 ">
  <div className="sm:flex sm:flex-col items-center justify-center">
    <div className="font-semibold   items-center space-y-2 m-4 sm:text-[10px] text-[#202124] dark:text-black font-sans flex sm:space-x-[100px] space-x-[160px] text-[14px]">
      <div className=" items-end">
        <p className="mb-2  dark:text-white">Monthly</p>
        <p className="dark:text-white">Taxes</p>
      </div>
      <div className="ml-[70px] mb-3 dark:text-wh ">
        <p className="mb-2 dark:text-white">300,000 UGX</p>
        <p className="dark:text-white">10,000 UGX</p>
      </div>
    </div>
    <div className="border-[1px] sm:w-[250px] w-[300px]  ml-4 mb-7"></div>
    <div className="font-semibold items-end  sm:text-[10px] flex mb-4 sm:mb-0 ml-4 sm:space-x-[100px] space-x-[160px] dark:text-black text-[14px]">
      <p className="dark:text-white">Subtotal</p>
      <p className="dark:text-white">310,000 UGX</p>
    </div>
    <div className="border-[1px] sm:w-[250px] w-[300px] sm:mb-2 mb-6 ml-4 "></div>
  </div>
  <div className="mt-10 ">
    <Link to="/">
      <button className="bg-[#0049F5] font-bold text-white w-[315px]  p-3 rounded-[27.34px]  m sm:m-0">
        Pay
      </button>
    </Link>
  </div>
</div>

        </div>
      </div>

      </div>
      <h3 className=" md:block hidden dark:text-black absolute text-[12px] text-[#878787] font-[900] mt-9  sm:left-[50%]  bottom-[70px] left-[40%]">
          Terms and conditions{" "}
      </h3>
      <Bottombar activeBar={'settings'} />
    </div>
  );
}

export default SubcriptionAndPaymentScreen;
